export const AUTH_API_BASE_URL = "/auth/v1";
